import React from "react";

import KYBVerification from "./KYBVerification/KYBVerification";
import Profile from "./Settings/Profile/Profile";
import Users from "./Settings/Users/Users";
import ManageRoles from "./Settings/Users/ManageRoles";
import DefaultRoles from "./Settings/Users/ManageRoles/DefaultRoles";
import CustomRoles from "./Settings/Users/ManageRoles/CustomRoles";
import RolePage from "./Settings/Users/ManageRoles/RolePage";
import Settlements from "./Settings/Settlements/Settlements";
import ApiKeys from "./Settings/APIKeys/ApiKeys";
import AccountSettings from "./Settings/AccountSettings/AccountSettings";
import Documentation from "./Documentation/Documentation";
import TransactionDetails from "./Payments/Transactions/TransactionDetails";
import CustomerDetails from "./Customers/CustomerDetails/CustomerDetails";
import CreateCustomer from "./Customers/CreateCustomer";
import UpdateCustomer from "./Customers/UpdateCustomer";
import AllTransactions from "./Payments/Transactions/AllTransactions";
import Expenses from "./Expenses/Expenses";
import CreateCampaign from "./Loyalty/Campaign/CreateCampaign";
import LoyaltyNotification from "./Loyalty/LoyaltyNotification/LoyaltyNotification";
import ApprovedTransfers from "./Payments/Transfers/ApprovedTransfers/ApprovedTransfers";
import PendingTransfers from "./Payments/Transfers/PendingTransfers/PendingTransfers";
import RejectedTransfers from "./Payments/Transfers/RejectedTransfers/RejectedTransfers";
import TransferDetails from "./Payments/Transfers/TransferDetails";
import AllTransfers from "./Payments/Transfers/AllTransfers";
import AllSubAccounts from "./Payments/SubAccounts/AllSubAccounts/SubAccounts";
import CreateSubAccount from "./Payments/SubAccounts/CreateSubAccount";
import AllTerminals from "./Terminals/AllTerminals/AllTerminals";
import TerminalRequests from "./Terminals/TerminalRequests/TerminalRequests";
import NewTerminal from "./Terminals/NewTerminal/NewTerminal";
import Terminals from "./Terminals/Terminals";
import TerminalDetails from "./Terminals/TerminalDetails/TerminalDetails";
import TerminalCredentials from "./Terminals/TerminalCredentials/TerminalCredentials";
import Overview from "./Dashboard/Overview";
import CustomerAnalytics from "./Dashboard/CustomerAnalytics";
import CashflowAnalytics from "./Dashboard/CashflowAnalytics";
import SavedBeneficiaries from "./Payments/Transfers/SavedBeneficiaries/SavedBeneficiaries";
import Tags from "./Payments/Tags/Tags";
import Inventory from "./Inventory/Inventory";
import ProductCategories from "./Inventory/ProductCategories/ProductCategories";
import Stores from "./Inventory/Stores/AllStores/Stores";
import CreateStore from "./Inventory/Stores/CreateStore";
import EditStore from "./Inventory/Stores/EditStore";
import AddSingleProduct from "./Inventory/SingleProducts/AddSingleProduct";
import AddMultipleProducts from "./Inventory/AddMultipleProducts/AddMultipleProducts";
import SalesTransactions from "./Inventory/SalesTransactions";
import EditStoreDetails from "./Inventory/EditStoreDetails";
import EditProduct from "./Inventory/SingleProducts/EditProduct";
import AllGiftCards from "./Loyalty/GiftCard/AllGiftCards";
import CreateGiftCard from "./Loyalty/GiftCard/CreateGiftCard";
import EditCampaign from "./Loyalty/Campaign/EditCampaign";
import EditGiftCard from "./Loyalty/GiftCard/EditGiftCard";
import LoyaltyCustomeHistory from "./Loyalty/LoyaltyCustomeHistory";
import LoyaltyCustomer from "./Loyalty/LoyaltyCustomer";
import LoyaltyCustomerDetails from "./Loyalty/LoyaltyCustomerDetails";
import StockHistory from "./Inventory/StockHistory/StockHistory";
import CreditLog from "./Inventory/CreditLogs/CreditLog";
import Subscriptions from "./Settings/Subscriptions";
import SubscriptionHistory from "./Settings/Subscriptions/SubscriptionHistory";
import SubscriptionPlans from "./Settings/Subscriptions/SubscriptionPlans";
import InventoryAnalyticsPage from "./Inventory/InventoryAnalytics/Index";
import AllStores from "./AllStores";
import EditService from "./Inventory/SingleProducts/EditService";
import ProductStockHistory from "./Inventory/ProductStockHistory";
import CreditLogDetails from "./Inventory/CreditLogs/CreditLogDetails";
import InventoryTables from "./Inventory/Tables";
import InventoryTableDetails from "./Inventory/TableDetails";
import Suppliers from "./Inventory/Suppliers";
import EditSupplier from "./Inventory/EditSupplier";
import ExpenseDetails from "./Expenses/ExpenseDetails";
import ExpenseCategories from "./Expenses/ExpenseCategories";
import ExpenseAnalytics from "./Expenses/ExpenseAnalytics";
import AllReconciliations from "./Inventory/Reconciliation/AllReconciliations";
import ReconcileStocks from "./Inventory/Reconciliation/ReconcileStocks";
import ReconciliationReview from "./Inventory/Reconciliation/ReconciliationReview";
import AccountingOverview from "./Accounting/Accounting";
import AccountingDetails from "./Accounting/AccountingDetails";
import SupplierDetails from "./Inventory/SupplierDetails/SupplierDetails";
import BulkRestock from "./Inventory/BulkRestock";
import ContinueBulkRestock from "./Inventory/Procurement/Restock/ContinueBulkRestock";
import InvoiceDetails from "./Inventory/InvoiceDetails";
import SubscriptionSelection from "./Settings/Subscriptions/SubscriptionSelection";
import AllFoodMenu from "./Inventory/FoodMenus/AllFoodMenus";
import PaymentSetup from "./Inventory/FoodMenus/CreateFoodMenu/components/PaymentSetup";
import CreateCompositeProduct from "./Inventory/CompositeProducts/CreateCompositeProduct";
import EditCompositeProducts from "./Inventory/CompositeProducts/EditCompositeProduct";
import ProfitAndLost from "./Accounting/ProfitAndLost";
import MainDashboard from "./MainDashboard";
import AllSections from "./AllSections";
import ManageSections from "./Inventory/ManageSections";
import AllCampaigns from "./Loyalty/Campaign/AllCampaigns";
import StockTransferHistory from "./Inventory/StockTransfer/AllStockTransfer";
import CreateStockTransfer from "./Inventory/StockTransfer/CreateTransfer";
import TransferStockDetails from "./Inventory/StockTransfer/TransferStockDetails";
import EditStockTransfer from "./Inventory/StockTransfer/EditStockTransfer";
import TrackItem from "./Inventory/TrackItem";
import AllMarkets from "./MarketPlace/AllMarkets";
import MarketDetails from "./MarketPlace/MarketDetails";
import GeneraLedger from "./Accounting/GeneraLedger";
import ChartOfAccounts from "./Accounting/ChartOfAccounts";
import AllShippings from "./Inventory/Shippings/AllShippings";
import AllRiders from "./Inventory/Riders/AllRiders";
import AllStorefront from "./Inventory/Storefront/AllStorefront";
import StorefrontSettingsCheckout from "./Inventory/FoodMenus/CreateFoodMenu/components/CustomizatonNavigation/Tabs/Checkout";
import StorefrontSettingsPayment from "./Inventory/FoodMenus/CreateFoodMenu/components/CustomizatonNavigation/Tabs/Payment";
import StorefrontSettingsTemplates from "./Inventory/FoodMenus/CreateFoodMenu/components/CustomizatonNavigation/Tabs/Templates";
import StorefrontSettingsBranding from "./Inventory/FoodMenus/CreateFoodMenu/components/CustomizatonNavigation/Tabs/Branding";
import StorefrontSettingsSortCategories from "./Inventory/FoodMenus/CreateFoodMenu/components/CustomizatonNavigation/Tabs/SortStorefrontCategories";
import CustomizationNavigation from "./Inventory/FoodMenus/CreateFoodMenu/components/CustomizatonNavigation";
import CreateShippingForm from "./Inventory/FoodMenus/CreateFoodMenu/components/Shipping";
import ProductsBatch from "./Inventory/ProductsBatch/AllProductsBatch";
import EditProductsBatch from "./Inventory/ProductsBatch/EditProductsBatch";
import AllStoreWalllet from "./Inventory/StoreWallet/AllStoreWallets";
import StoreWalletDetails from "./Inventory/StoreWallet/StoreWalletDetails";
import StoreWalletTransactionDetails from "./Inventory/StoreWallet/StoreWalletTransactionDetails";
import BusinessProfile from "./Settings/Profile/BusinesProfile";
import UserProfile from "./Settings/Profile/UserProfile";
import RequestCapital from "./RequestCapital";
import SecurityPinAndQuestion from "./SecurityPinAndQuestion";
import ApiManagement from "./MarketPlace/Chowdeck/ApiManagement";
import AllConnections from "./MarketPlace/Chowdeck/AllConnections";
import PrinterConfiguration from "./Inventory/PrinterSettings/PrinterConfiguration";
import CashierStores from "./AllStores/CashierStores";
import PrintCustomaizationPage from "./Inventory/PrinterSettings/PrintCustomization";
import AllSettings from "./Inventory/PrinterSettings/AllSettings";
import Returns from "./Inventory/Returns";
import ReturnReview from "./Inventory/Returns/ReturnReview";
import StockRemovals from "./Inventory/StockRemovals";
import StockRemovalReview from "./Inventory/StockRemovals/StockRemovalReview";
import Rebates from "./Accounting/Rebates";
import Waybills from "./Procurement/Waybills/Waybills";
import ReStockLogs from "./Inventory/Procurement/Restock/RestockLogs";
import RestockDrafts from "./Inventory/Procurement/Restock/RestockDrafts";
import GenerateWaybill from "./Procurement/Waybills/GenerateWaybill";
import ViewWaybill from "./Procurement/Waybills/ViewWaybill";
import CreateProduct from "./Inventory/SingleProducts/CreateProduct";
import CreateService from "./Inventory/SingleProducts/CreateService";
import AIAssistance from "./AIAssistance";
import LumiAiAssistant from "./LumiAiAssistant";
import AllSmsCampaigns from "./Marketing/SmsCampaign/AllSmsCampaigns";
import AllSmsAutomatedCampaigns from "./Marketing/SmsCampaign/AllSmsAutomatedCampaigns";
import CreateSmsCampaign from "./Marketing/SmsCampaign/CreateSmsCampaign";
import SmsCampaignContext from "./Marketing/SmsCampaign/SmsCampaignContext";
import SmsCampaignAudience from "./Marketing/SmsCampaign/SmsCampaignAudience";
import SmsCampaignContent from "./Marketing/SmsCampaign/SmsCampaignContent";
import SmsCampaignReview from "./Marketing/SmsCampaign/SmsCampaignReview";
import SmsCampaignSchedule from "./Marketing/SmsCampaign/SmsCampaignSchedule";
import CreateSmsCampaignContext from "./Marketing/SmsCampaign/CreateSmsCampaignContext";
import PlatformCreditHistory from "./Settings/PlatformCredit/PlatformCreditHistory";
import PlatformCreditTopUp from "./Settings/PlatformCredit/PlatformCreditTopUp";
import VatLogsPage from "./Inventory/VatLogs";
import AccountSettingsPage from "./Accounting/AccountSettings";
import JournalEntries from "./Accounting/JournalEntries";
import CreateJournalEntry from "./Accounting/CreateJournalEntry";
import EditJournalEntry from "./Accounting/EditJournalEntry";
import JournalEntryDetails from "./Accounting/JournalEntryDetails";
import ChartAccountTransactionDetails from "./Accounting/ChartAccountTransactionDetails";
import AccountingReports from "./Accounting/AccountingReports";
import SquareupAuth from "./MarketPlace/Squareup/SquareupAuth";
import CreateStorfront from "./Inventory/Storefront/CreateStorfront";
import UpdateStorefront from "./Inventory/Storefront/UpdateStorefront";
import ChartAccountDetails from "./Accounting/ChartAccountDetails";

const AllCustomers = React.lazy(() => import("./Customers/AllCustomers"));
const AllServices = React.lazy(
  () => import("../appPages/Inventory/Products/Service/AllServices"),
);
const AllProducts = React.lazy(
  () => import("../appPages/Inventory/Products/Product/AllProducts"),
);
const AllCompositeProducts = React.lazy(
  () =>
    import("../appPages/Inventory/Products/CompositeProduct/AllCompositeProducts"),
);

const CreateChowdeckStoreConnection = React.lazy(
  () => import("./MarketPlace/Chowdeck/CreateChowdeckStoreConnection"),
);
const UpdateChowdeckStoreConnection = React.lazy(
  () => import("./MarketPlace/Chowdeck/UpdateChowdeckStoreConnection"),
);
const SquareupConnections = React.lazy(
  () => import("./MarketPlace/Squareup/SquareupConnections"),
);
const SquareupAuthCallback = React.lazy(
  () => import("./MarketPlace/Squareup/SquareupAuthCallback"),
);
const CreateSquareupConnection = React.lazy(
  () => import("./MarketPlace/Squareup/CreateSquareupConnection"),
);
const UpdateSquareupConnection = React.lazy(
  () => import("./MarketPlace/Squareup/UpdateSquareupConnection"),
);
const CreateStorefrontCover = React.lazy(
  () => import("./Inventory/Storefront/CreateStorefrontCover"),
);

const appPages = {
  AllGiftCards,
  CreateGiftCard,
  KYBVerification,
  Profile,
  Users,
  ManageRoles,
  DefaultRoles,
  CustomRoles,
  RolePage,
  Settlements,
  ApiKeys,
  AccountSettings,
  Documentation,
  TransactionDetails,
  CustomerDetails,
  AllCustomers,
  CreateCustomer,
  UpdateCustomer,
  AllTransactions,
  CreateCampaign,
  LoyaltyNotification,
  Overview,
  ApprovedTransfers,
  PendingTransfers,
  RejectedTransfers,
  TransferDetails,
  AllTransfers,
  AllSubAccounts,
  CreateSubAccount,
  AllTerminals,
  TerminalRequests,
  NewTerminal,
  Terminals,
  TerminalDetails,
  TerminalCredentials,
  CustomerAnalytics,
  CashflowAnalytics,
  SavedBeneficiaries,
  Tags,
  Inventory,
  ProductCategories,
  Stores,
  AddSingleProduct,
  AddMultipleProducts,
  SalesTransactions,
  EditStoreDetails,
  EditProduct,
  EditCampaign,
  EditGiftCard,
  LoyaltyCustomeHistory,
  LoyaltyCustomer,
  LoyaltyCustomerDetails,
  StockHistory,
  CreditLog,
  CreditLogDetails,
  Subscriptions,
  SubscriptionHistory,
  SubscriptionPlans,
  InventoryAnalyticsPage,
  AllStores,
  AllProducts,
  EditService,
  ProductStockHistory,
  InventoryTables,
  InventoryTableDetails,
  Expenses,
  ExpenseDetails,
  ExpenseCategories,
  ExpenseAnalytics,
  Suppliers,
  EditSupplier,
  AllReconciliations,
  ReconcileStocks,
  ReconciliationReview,
  AccountingOverview,
  AccountingDetails,
  SupplierDetails,
  BulkRestock,
  ContinueBulkRestock,
  InvoiceDetails,
  SubscriptionSelection,
  AllFoodMenu,
  PaymentSetup,
  CreateCompositeProduct,
  EditCompositeProducts,
  ProfitAndLost,
  MainDashboard,
  AllSections,
  ManageSections,
  AllCampaigns,
  StockTransferHistory,
  CreateStockTransfer,
  TransferStockDetails,
  EditStockTransfer,
  TrackItem,
  AllMarkets,
  MarketDetails,
  AllConnections,
  ApiManagement,
  GeneraLedger,
  ChartOfAccounts,
  AllShippings,
  AllRiders,
  CreateStore,
  EditStore,
  CustomizationNavigation,
  CreateShippingForm,
  StorefrontSettingsCheckout,
  StorefrontSettingsPayment,
  StorefrontSettingsTemplates,
  StorefrontSettingsBranding,
  StorefrontSettingsSortCategories,
  ProductsBatch,
  EditProductsBatch,
  AllStoreWalllet,
  StoreWalletDetails,
  StoreWalletTransactionDetails,
  BusinessProfile,
  UserProfile,
  RequestCapital,
  SecurityPinAndQuestion,
  PrinterConfiguration,
  CashierStores,
  PrintCustomaizationPage,
  AllSettings,
  Returns,
  ReturnReview,
  StockRemovals,
  StockRemovalReview,
  Rebates,
  Waybills,
  ReStockLogs,
  RestockDrafts,
  GenerateWaybill,
  ViewWaybill,
  CreateProduct,
  CreateService,
  AIAssistance,
  LumiAiAssistant,
  AllSmsCampaigns,
  AllSmsAutomatedCampaigns,
  CreateSmsCampaign,
  SmsCampaignContext,
  SmsCampaignAudience,
  SmsCampaignContent,
  SmsCampaignReview,
  SmsCampaignSchedule,
  PlatformCreditHistory,
  PlatformCreditTopUp,
  CreateSmsCampaignContext,
  VatLogsPage,
  AccountSettingsPage,
  JournalEntries,
  CreateJournalEntry,
  EditJournalEntry,
  JournalEntryDetails,
  ChartAccountTransactionDetails,
  AccountingReports,
  ChartAccountDetails,

  AllServices,
  AllCompositeProducts,
  CreateChowdeckStoreConnection,
  UpdateChowdeckStoreConnection,
  SquareupAuth,
  SquareupConnections,
  SquareupAuthCallback,
  CreateSquareupConnection,
  UpdateSquareupConnection,
  CreateStorefrontCover,
  CreateStorfront,
  UpdateStorefront,
  AllStorefront,
};

export default appPages;

export * from "./Inventory/Procurement/PurchaseOrder/AllPurchaseOrders";
export * from "./Inventory/Procurement/PurchaseOrder/CreatePurchaseOrder";
export * from "./Inventory/Procurement/PurchaseOrder/EditPurchaseOrder";
export * from "./Inventory/Procurement/PurchaseOrder/PurchaseOrderDetails";
export * from "./Inventory/Procurement/GoodsReceived/AllGoodsReceived";
export * from "./Inventory/Procurement/GoodsReceived/CreateGoodsReceived";
export * from "./Inventory/Procurement/GoodsReceived/GoodsReceivedDetails";
export * from "./Inventory/Procurement/GoodsReceived/EditGoodsReceived";
export * from "./Performance/Goals/AllGoals";
export * from "./Performance/Goals/GoalsDetails";
export * from "./Inventory/Procurement/Bills/AllBills";
export * from "./Inventory/Procurement/Bills/CreateBills";
export * from "./Inventory/Procurement/Bills/EditBills";
export * from "./Inventory/Procurement/Bills/BillsDetails";
export * from "./Inventory/Procurement/POCategories/AllPOCategories";
export * from "./MarketPlace/IntegratedTerminals/AllIntegratedTerminals";
export * from "./MarketPlace/IntegratedTerminals/EditIntegratedTerminals";
export * from "./MarketPlace/IntegratedTerminals/AllBusinessConnections";
export * from "./Expenses/CreateBulkExpense";
export * from "./Expenses/ExpenseDepartments";
export * from "./General/BusinessSupplierConsentHome";
export * from "./Settings/ActivityLogs/AllActivityLogs";
export * from "./Settings/ActivityLogs/ActivityLogDetails";
